













































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { workflowDataType } from "@/components/Workflow/workflowDataType";
import { nodeData } from "@/components/Workflow/nodeData";
import { ia_agents_store } from "@/shared/classes/ia_agents_store";
import { workflow_storage } from "@/shared/services/workflow_storage";

interface ChatMsg {
  role: "user" | "assistant" | "system";
  content: string;
}

@Component({
  components: {},
})
export default class workflow_chat_runner extends Vue {
  // Prop opcional: si se pasa workflow directamente
  @Prop({ required: false }) readonly workflow?: workflowDataType;

  public draft: string = "";
  public isLoading: boolean = false;
  public messages: ChatMsg[] = [];
  public currentWorkflow: workflowDataType | null = null;

  public mounted() {
    this.loadWorkflow();
  }

  public get headerTitle(): string {
    if (this.currentWorkflow && this.currentWorkflow.name) {
      return this.currentWorkflow.name;
    }
    return "Workflow";
  }

  public get agentsCount(): number {
    const arr = this.orderedAgents;
    if (arr && arr.length) {
      return arr.length;
    }
    return 0;
  }

  private loadWorkflow() {
    // Prioridad 1: Prop workflow

    if (this.workflow) {
      this.currentWorkflow = this.workflow;
      return;
    }

    // Prioridad 2: Parámetro de ruta
    const routeParams: any =
      this.$route && this.$route.params ? this.$route.params : {};
    const routeId: string = routeParams.id;
    if (routeId) {
      const wf1 = workflow_storage.byId(routeId);
      if (wf1) {
        this.currentWorkflow = wf1;

        console.log(this.currentWorkflow, this.workflow);
        return;
      }
    }

    // Prioridad 3: Query parameter
    const routeQuery: any =
      this.$route && this.$route.query ? this.$route.query : {};
    const queryId: string = routeQuery.workflowId;
    if (queryId) {
      const wf2 = workflow_storage.byId(queryId);
      if (wf2) {
        this.currentWorkflow = wf2;

        console.log(this.currentWorkflow, this.workflow);
        return;
      }
    }

    // Fallback: mostrar error
    this.messages.push({
      role: "assistant",
      content:
        "No se pudo cargar el workflow. Verifica que el ID sea correcto.",
    });
  }

  public get orderedAgents(): nodeData[] {
    if (!this.currentWorkflow) {
      return [];
    }

    const nodes: nodeData[] = this.currentWorkflow.nodes
      ? this.currentWorkflow.nodes
      : [];
    const conns: any[] = this.currentWorkflow.connections
      ? (this.currentWorkflow.connections as any[])
      : [];

    const idToNode = new Map<string, nodeData>(
      nodes.map(function(n) {
        return [n.id, n] as [string, nodeData];
      })
    );
    const incoming = new Map<string, number>();
    for (let i = 0; i < nodes.length; i++) {
      incoming.set(nodes[i].id, 0);
    }
    for (let j = 0; j < conns.length; j++) {
      const c = conns[j];
      const cur = incoming.get(c.to) || 0;
      incoming.set(c.to, cur + 1);
    }

    // candidatos iniciales: sin entradas
    const queue: string[] = [];
    for (let k = 0; k < nodes.length; k++) {
      const n = nodes[k];
      if ((incoming.get(n.id) || 0) === 0) {
        queue.push(n.id);
      }
    }

    // orden lineal (tolerante)
    const order: string[] = [];
    const outMap = new Map<string, string[]>();
    for (let i2 = 0; i2 < conns.length; i2++) {
      const c = conns[i2];
      const list = outMap.get(c.from) || [];
      list.push(c.to);
      outMap.set(c.from, list);
    }

    const seen = new Set<string>();
    while (queue.length > 0) {
      const id = queue.shift() as string;
      if (seen.has(id)) {
        continue;
      }
      seen.add(id);
      order.push(id);
      const outs = outMap.get(id) || [];
      for (let z = 0; z < outs.length; z++) {
        const next = outs[z];
        const inVal = incoming.get(next);
        const newVal = (typeof inVal === "number" ? inVal : 1) - 1;
        incoming.set(next, newVal > 0 ? newVal : 0);
        if ((incoming.get(next) || 0) === 0) {
          queue.push(next);
        }
      }
    }

    // fallback si hubo ciclo: usar el orden original
    const finalIds =
      order.length > 0
        ? order
        : nodes.map(function(n) {
            return n.id;
          });

    // si existe un nodo "OUTPUT", colócalo al final
    const outputIdx = finalIds.indexOf("OUTPUT");
    const filtered: string[] = [];
    for (let i3 = 0; i3 < finalIds.length; i3++) {
      if (finalIds[i3] !== "OUTPUT") {
        filtered.push(finalIds[i3]);
      }
    }
    if (outputIdx >= 0) {
      filtered.push("OUTPUT");
    }

    // solo ids que existan en store y mapeen a agente
    const result: nodeData[] = [];
    for (let i4 = 0; i4 < filtered.length; i4++) {
      const nd = idToNode.get(filtered[i4]);
      if (nd && ia_agents_store.get(nd.id)) {
        result.push(nd);
      }
    }
    return result;
  }

  public async onSend() {
    if (this.isLoading) return;
    const txt = this.draft ? this.draft.trim() : "";
    if (!txt || !this.currentWorkflow) return;

    this.messages.push({ role: "user", content: txt });
    this.draft = "";
    this.isLoading = true;

    try {
      const result = await this.runThroughAgents(txt);
      this.messages.push({ role: "assistant", content: result });
    } catch (err) {
      this.messages.push({
        role: "assistant",
        content: "Ocurrió un error procesando el workflow.",
      });
    } finally {
      this.isLoading = false;
    }
  }

  // Pasa el texto por cada agente en orden; la salida alimenta al siguiente
  private async runThroughAgents(initialText: string): Promise<string> {
    let current = initialText;

    const list = this.orderedAgents;
    console.log(list);
    for (let i = 0; i < list.length; i++) {
      const node = list[i];
      const agent: any = ia_agents_store.get(node.id);
      if (!agent) {
        continue;
      }
      // DEPURACIÓN: loguear el agente y el input/salida en cada paso
      // eslint-disable-next-line no-console
      console.log(
        "[WorkflowChatRunner] Paso agente:",
        agent.name || agent.id,
        "kind:",
        agent.kind,
        "IN:",
        current
      );

      if (agent.kind === "http" && agent.http && agent.http.url) {
        const r = await this.callHttpAgent(current, agent);
        current = r || current;
      } else {
        // por defecto, LLM
        const systemPrompt = agent.systemPrompt || "";
        const msgs: ChatMsg[] = [
          { role: "system", content: systemPrompt },
          { role: "user", content: current },
        ];
        const r = await this.callModel(msgs);
        current = r || current;
      }
    }

    return current;
  }

  private async callModel(messages: ChatMsg[]): Promise<string> {
    // Construir el payload
    const payload: any = {
      messages: [],
      model: "gpt-4o-mini",
      max_tokens: 700,
      temperature: 0.7,
    };

    for (let i = 0; i < messages.length; i++) {
      const m = messages[i];
      payload.messages.push({ role: m.role, content: m.content });
    }

    // Llamada HTTP
    let resp: any = null;
    try {
      resp = await axios.post(
        "https://public-api.devexpress.com/demo-openai/openai/deployments/gpt-4o-mini/chat/completions?api-version=2024-02-01",
        payload,
        {
          headers: {
            "api-key": "DEMO",
            accept: "application/json",
            "content-type": "application/json",
          },
        }
      );
    } catch (err) {
      // Compatible con axios 0.19.2
      // tslint:disable-next-line:no-console
      console.error("Error en llamada a modelo:", err);
      return "";
    }

    // Extraer respuesta de forma segura
    if (!resp || !resp.data) {
      return "";
    }

    const data = resp.data;
    const choices = data && data.choices ? data.choices : null;
    if (choices && choices.length > 0) {
      const first = choices[0];
      if (first && first.message && typeof first.message.content === "string") {
        return first.message.content;
      }
    }

    return "";
  }

  private renderTemplate(tpl: string, input: string): string {
    return tpl.replace(/{{\s*input\s*}}/g, input);
  }
/*
  private pickByPath(obj: any, path?: string): any {
    if (!path) return obj;
    const parts = path.split(".");
    let acc = obj;
    for (let i = 0; i < parts.length; i++) {
      const key = parts[i];
      if (acc && typeof acc === "object" && key in acc) {
        acc = acc[key];
      } else {
        return undefined;
      }
    }
    return acc;
  }
*/
  // Helpers
private renderTemplateRaw(tpl: string, input: string): string {
  // Sustituye {{input}} tal cual (para body JSON string o texto)
  return (tpl || "").replace(/{{\s*input\s*}}/g, input);
}
private renderTemplateEncoded(tpl: string, input: string): string {
  // Para URL y query: inyecta encodeURIComponent(input)
  return (tpl || "").replace(/{{\s*input\s*}}/g, encodeURIComponent(input));
}
private renderTemplateHeaders(headers: Record<string, string> | undefined, input: string) {
  const out: Record<string, string> = {};
  const src = headers || {};
  for (const k of Object.keys(src)) {
    out[k] = this.renderTemplateRaw(src[k], input);
  }
  return out;
}
private pickByPath(obj: any, path?: string): any {
  if (!path) return obj;
  return path.split(".").reduce((acc, k) => (acc != null ? acc[k] : undefined), obj);
}

// Método revisado
private async callHttpAgent(input: string, agent: any): Promise<string> {
  const cfg = (agent && agent.http) || {};
  const method = String(cfg.method || "POST").toUpperCase();
  const timeout = typeof cfg.timeoutMs === "number" ? cfg.timeoutMs : 15000;

  // 1) URL con {{input}} (encode para query/segmentos)
  const finalUrl = this.renderTemplateEncoded(cfg.url || "", input);

  // 2) Headers con {{input}} (sin encode)
  let headers: Record<string, string> = this.renderTemplateHeaders(cfg.headers, input);

  // 3) Auth automática si no viene en headers:
  if (!headers["authorization"]) {
    if (cfg.authType === "bearer" && cfg.authToken) {
      headers["authorization"] = "Bearer " + cfg.authToken;
    } else if (cfg.authType === "basic" && cfg.authUser && cfg.authPassword) {
      const token = btoa(cfg.authUser + ":" + cfg.authPassword);
      headers["authorization"] = "Basic " + token;
    }
  }

  // 4) Body con {{input}} (sin encode). Si es JSON válido, lo parseamos; si no, enviamos string.
  let dataToSend: any = undefined;
  if (cfg.bodyTemplate && ["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
    const bodyStr = this.renderTemplateRaw(cfg.bodyTemplate, input);
    try {
      dataToSend = JSON.parse(bodyStr);
    } catch {
      dataToSend = bodyStr;
    }
    // Si el cuerpo es objeto y no hay content-type, ponemos application/json
    if (typeof dataToSend === "object" && !headers["content-type"] && !headers["Content-Type"]) {
      headers["content-type"] = "application/json";
    }
  }

  // 5) Cliente HTTP (usa $axios si existe; si no, axios importado)
  const httpClient: any = (this as any).$axios && (this as any).$axios.request ? (this as any).$axios : (await import("axios")).default;

  try {
    const resp = await httpClient.request({
      url: finalUrl,
      method,
      headers,
      data: dataToSend,
      timeout
    });

    const payload = resp && resp.data !== undefined ? resp.data : resp;
    const picked = this.pickByPath(payload, cfg.resultPath);
    if (picked == null) {
      return typeof payload === "string" ? payload : JSON.stringify(payload);
    }
    return typeof picked === "string" ? picked : JSON.stringify(picked);
  } catch (err) {
    console.error("HTTP agent error:", err);
    return "";
  }
}

  // --- Métodos usados en el template deben ser públicos (sin "private") ---

  // Detectar si el contenido es HTML
  public isHtmlContent(content: string): boolean {
    const htmlRegex = /<[^>]+>/;
    return htmlRegex.test(content) && content.length > 50;
  }

  public onIframeLoad(event: Event) {
    const iframe = event && (event.target as HTMLIFrameElement);
    if (!iframe) {
      return;
    }
    try {
      if (iframe.contentDocument && iframe.contentDocument.body) {
        const height = iframe.contentDocument.body.scrollHeight;
        iframe.style.height = (height < 400 ? height : 400) + "px";
      }
    } catch (_e) {
      // Si hay CORS, usar altura fija
      iframe.style.height = "300px";
    }
  }
}
